module.exports = require("tailwind-override");